import { render } from "./SeoKnowledgeSection.vue?vue&type=template&id=32b108de&scoped=true"
import script from "./SeoKnowledgeSection.vue?vue&type=script&lang=js"
export * from "./SeoKnowledgeSection.vue?vue&type=script&lang=js"

import "./SeoKnowledgeSection.vue?vue&type=style&index=0&id=32b108de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b108de"]])

export default __exports__